var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import id from "@irati/utils/id";
import authentication from "@irati/auth";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import tracking from "@irati-tracking/platform";
import { shouldShowHomepage } from "@irati/products/utils/products";
import HeaderLink from "../shared/HeaderLink";
import CurrentApp from "../shared/CurrentApp";
import MobileMenuToggle from "./MobileMenuToggle";
import Search from "../shared/Search";
import { SECONDARY_NAV_CONTEXT } from "./const";
import { HeaderWrapper, HeaderSeparator } from "../styled";
var HeaderMobile = /** @class */ (function (_super) {
    __extends(HeaderMobile, _super);
    function HeaderMobile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderMobile.prototype.render = function () {
        var _a = this.props, togglePanel = _a.togglePanel, auth = _a.auth;
        var user = auth.user;
        var _b = this.context, appPath = _b.appPath, contextApps = _b.apps;
        var PERKS = contextApps.PERKS, HOME = contextApps.HOME, RECOGNITION = contextApps.RECOGNITION, MEDICAL = contextApps.MEDICAL, ADMIN = contextApps.ADMIN;
        var isPerksSection = appPath === PERKS;
        var isAdminSection = appPath === ADMIN;
        var isHomepage = appPath === HOME;
        var isLoggedIn = authentication.isLoggedIn();
        var isGlobalAdmin = authentication.isGlobalAdmin();
        var idNamespace = id("header", this.props, { force: true });
        var showSecondaryNavIcon = RECOGNITION === appPath || (MEDICAL === appPath && isGlobalAdmin);
        return (React.createElement(HeaderWrapper, null, isLoggedIn && (React.createElement(Flex, { justifyContent: "space-between", width: "100%", padding: 1 },
            React.createElement(Flex, { alignItems: "center" },
                !isHomepage && !isAdminSection && shouldShowHomepage() && (React.createElement(React.Fragment, null,
                    React.createElement(HeaderLink, { to: "/", app: HOME, noMarginLeft: true, onClick: function () { return tracking.clickHeaderHomeButton({ source: window.location.href }); } },
                        React.createElement(Icon, { icon: IconTypes.home, size: 24 })),
                    React.createElement(HeaderSeparator, null))),
                React.createElement(CurrentApp, { id: idNamespace })),
            React.createElement(Flex, { alignItems: "center" },
                React.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                    isPerksSection && React.createElement(Search, { id: id("link-search-desktop", idNamespace) }),
                    React.createElement(MobileMenuToggle, { id: idNamespace, user: user, togglePanel: togglePanel }),
                    showSecondaryNavIcon && (React.createElement(HeaderLink, { onClick: function () { return togglePanel(SECONDARY_NAV_CONTEXT); } },
                        React.createElement(Icon, { icon: "mobileSecondaryNav" })))))))));
    };
    HeaderMobile.contextTypes = {
        apps: PropTypes.object.isRequired,
        appPath: PropTypes.string.isRequired
    };
    return HeaderMobile;
}(PureComponent));
export default HeaderMobile;
